import { BlankState, StateChanges } from './stateChanges'
import { RunStates } from './runStates'
import router from '../router'

const basicMutations = {
  [StateChanges.SAVE_UPPY_STATE]: function (state, obj) {
    Object.assign(state.uppyState, obj)
  },
  [StateChanges.SET_TEXT_FOR_API_CALL]: function (state, newText) {
    state.textForApiCall = newText;
  },
  [StateChanges.SET_TEXT_STYLE]: function (state, value) {
    state.textStyle = value;
  },
  [StateChanges.SET_FILE_FORMAT]: function (state, value) {
    state.fileFormat = value;
  },
  [StateChanges.SET_URL_LIST]: function (state, value) {
    state.urlList = value;
  },
  [StateChanges.UPDATE_URL_LIST]: function (state, value) {
    state.urlList = state.urlList.concat(value)
    state.urlList = state.urlList.filter((v, i, a) => a.indexOf(v) === i)

  },
  [StateChanges.SET_USER_EMAIL]: function (state, value) {
    state.userEmail = value;
  },
  [StateChanges.SET_RESULTS]: function (state, data) {
    state.results = data
    let pars = state.results[0].UD.split('\n\n')
    let counter = 0
    state.UDarr = []
    //   let charCount = 0
    pars.forEach(el => {
      let parLines = el.split('\n')
      let temp = parLines.filter(ln => {
        return !ln.includes('#') && ln.length > 0
      })
      if (counter <= 100) {
        counter += temp.length
        state.UDarr = state.UDarr.concat(temp)
        //temp.forEach(ln => {
        //charCount += ln.length
        //})
      }
    })
    // state.UDcharLengthForDisplay = charCount
    // state.UDLineLength = counter
    if (router.currentRoute.name !== 'Results')
      router.push({ name: "Results" })
  },
  [StateChanges.SET_JOB_ID]: function (state, val) {
    state.jobId = val;
  },
  [StateChanges.SET_UPLOAD_STATUS]: function (state, data) {
    state.uploadStatus = data;
  },
  [StateChanges.MORPH_NOT_RUN]: function (state) {
    state.morphApiState = RunStates.NOT_RUN
  },
  [StateChanges.MORPH_RUNNING](state) {
    state.morphApiState = RunStates.RUNNING
  },
  [StateChanges.MORPH_FAILED]: function (state) {
    state.morphApiState = RunStates.FAILED
  },
  [StateChanges.MORPH_TIMED_OUT]: function (state) {
    state.morphApiState = RunStates.TIMED_OUT
  },
  [StateChanges.MORPH_COMPLETE]: function (state) {
    state.morphApiState = RunStates.COMPLETE
  },
  [StateChanges.RESET]: function (state) {
    Object.assign(state, JSON.parse(JSON.stringify(BlankState)))
  }
}

export default basicMutations
